// import React from 'react';
// import { Link } from 'react-router-dom';
// import logo from '/Users/MAC/Reactjs/GN-Constructions/src/Assets/logo.png';
// import './Navbar.css';

// const Navbar = () => {
//   return (
//     <>
//       <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
//         <div className="container">
//           {/* Brand/Logo */}
//           <Link className="navbar-brand" to="/">
//             <img src={logo} alt="Company Logo" className="d-inline-block align-top me-2" style={{  width:'25rem' }} />
//           </Link>

//           {/* Mobile Toggle Button */}
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarContent"
//             aria-controls="navbarContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           {/* Navbar Content */}
//           <div className="collapse navbar-collapse" id="navbarContent">
//             <div className="navbar-nav ms-auto nav-links">
//               <Link to="/" className="nav-link" >Home</Link>
//               <Link to="/about" className="nav-link" >About</Link>
//               <Link to="/services" className="nav-link" >Services</Link>
//               <Link to="/projects" className="nav-link" >Projects</Link>
//               <Link to="/contact" className="nav-link" >Contact</Link>
//               {/* <Link to="/Gallery" className="nav-link">Gallery</Link> */}
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Spacer to prevent content hiding */}
//       <div style={{ height: '80px' }}></div>
//     </>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '/Users/MAC/Reactjs/GN-Constructions/src/Assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img 
              src={logo} 
              alt="Company Logo" 
              className="logo-img"
            />
          </Link>

          {/* Mobile Menu Icon */}
          <div 
            className={`menu-icon ${isMobileMenuOpen ? 'open' : ''}`} 
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          {/* Desktop Menu */}
          <ul className="nav-menu">
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={closeMobileMenu}>Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-links" onClick={closeMobileMenu}>About</Link>
            </li>
            <li className="nav-item">
              <Link to="/services" className="nav-links" onClick={closeMobileMenu}>Services</Link>
            </li>
            <li className="nav-item">
              <Link to="/projects" className="nav-links" onClick={closeMobileMenu}>Projects</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>Contact</Link>
            </li>
          </ul>
        </div>
      </nav>

      {/* Half-page Mobile Menu */}
      <div className={`mobile-menu-container ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu">
          <Link to="/" className="mobile-link" onClick={closeMobileMenu}>Home</Link>
          <Link to="/about" className="mobile-link" onClick={closeMobileMenu}>About</Link>
          <Link to="/services" className="mobile-link" onClick={closeMobileMenu}>Services</Link>
          <Link to="/projects" className="mobile-link" onClick={closeMobileMenu}>Projects</Link>
          <Link to="/contact" className="mobile-link" onClick={closeMobileMenu}>Contact</Link>
        </div>
      </div>

      {/* Spacer */}
      <div className="navbar-spacer"></div>
    </>
  );
};

export default Navbar;